var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":_vm.siteKey,"data-theme":"light","data-callback":"verifyMethod","data-expired-callback":"expiredMethod","data-error-callback":"errordMethod"}})}
var staticRenderFns = []

export { render, staticRenderFns }